import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import { useDispatch, useSelector } from 'react-redux';

import SearchBox from 'core/forms/SearchBox';
import ReloadButton from 'core/buttons/ReloadButton';
import TableActionsContainer from 'core/table/TableActionsContainer';

import { getRolesAndPermissions } from 'app/features/roles-and-permissions/rolesAndPermissionsSaga';
import {
  setParam,
  deleteFilterParams,
} from 'app/features/roles-and-permissions/roleAndPermissionsSlice';
import { he } from 'date-fns/locale';

const STATUS_OPTIONS = [
  { value: '', label: 'Status' },
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
];

export default function RolesAndPermissionActions() {
  const dispatch = useDispatch();
  const { params } = useSelector((state) => state.rolesAndPermissions.index);

  const [search, setSearch] = useState(params?.search || '');
  const [status, setStatus] = useState(params?.status || '');

  const handleSearch = useCallback(
    (e) => {
      const value = e.target.value;
      setSearch(value);
      dispatch(setParam({ search: value, page_number: 1 }));
    },
    [dispatch],
  );

  const clearSearch = () => {
    setSearch('');
    dispatch(deleteFilterParams('search'));
  };

  const handleStatusChange = (e) => {
    const value = e.target.value;
    setStatus(value);
    dispatch(setParam({ status: value, page_number: 1 }));
  };

  const handleRefresh = () => {
    dispatch(getRolesAndPermissions({ ...params, page_number: 1 }));
  };

  return (
    <TableActionsContainer>
      <Box display="flex" justifyContent="space-between" alignItems="center"  width="100%" marginBottom={2}>
        <Box>
          <SearchBox
            placeholder="Search Role"
            value={search}
            onChange={handleSearch}
            onClickClearSearch={clearSearch}
          />
        </Box>
        <Box display="flex" alignItems="center" gap={2}>
          <Select
            displayEmpty
            value={status}
            size="small"
            onChange={handleStatusChange}
            input={<OutlinedInput />}
          >
            {STATUS_OPTIONS.map((item) => (
              <MenuItem key={item.value || 'all'} value={item.value}>
                {item.label}
              </MenuItem>
            ))}
          </Select>

          <ReloadButton onClick={handleRefresh} size="small" />
        </Box>
      </Box>
    </TableActionsContainer>
  );
}

RolesAndPermissionActions.propTypes = {
  table: PropTypes.object,
};
